import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

const runtimeEnv: any = (globalThis as any).window?.__ENV || {};
const API_BASE = (runtimeEnv.API_BASE || process.env.VITE_API_BASE || process.env.API_BASE || '').replace(/\/$/, '');

interface AuthContextType {
  isAuthenticated: boolean | null;
  isChecking: boolean;
  hasAccess: boolean;
  checkAuth: () => Promise<void>;
  login: () => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  const checkAuth = async () => {
    setIsChecking(true);
    try {
      const response = await fetch(`${API_BASE}/api/v1/genders/genders`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        setIsAuthenticated(true);
        setHasAccess(true);
      } else if (response.status === 401) {
        setIsAuthenticated(false);
        setHasAccess(false);
      } else if (response.status === 403) {
        setIsAuthenticated(true); // Авторизован, но нет доступа
        setHasAccess(false);
      } else {
        setIsAuthenticated(false);
        setHasAccess(false);
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
      setHasAccess(false);
    } finally {
      setIsChecking(false);
    }
  };

  const login = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${API_BASE}/api/v1/login?return_url=${returnUrl}`;
  };

  const logout = () => {
    window.location.href = `${API_BASE}/api/v1/logout`;
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, isChecking, hasAccess, checkAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

